import type { FeatureFlagItem, FeaturesCards } from '../../services/analytics';
import { DASH, formatBRL, formatInt, formatPct } from './format';
import type { MetricInfoKey } from './metricInfo';

export type FeaturesCardId = Extract<MetricInfoKey, 'movimentacoes' | 'entradas' | 'saidas' | 'resultado'>;

export interface FeaturesCardView {
    id: FeaturesCardId;
    title: string;
    value: string;
    caption: string;
}

const plural = (n: number, one: string, many: string) => `${formatInt(n)} ${n === 1 ? one : many}`;

/** Cards de lancamentos dos clientes, na ordem e com os textos do prototipo. */
export function buildFeaturesCards(c: FeaturesCards): FeaturesCardView[] {
    return [
        {
            id: 'movimentacoes',
            title: 'Movimentações',
            value: formatInt(c.movimentacoes.value),
            caption: `${plural(c.entradas.registros, 'entrada', 'entradas')} · ${plural(c.saidas.registros, 'saída', 'saídas')}`,
        },
        {
            id: 'entradas',
            title: 'Entradas',
            value: formatBRL(c.entradas.value),
            caption: plural(c.entradas.registros, 'registro', 'registros'),
        },
        {
            id: 'saidas',
            title: 'Saídas',
            value: formatBRL(c.saidas.value),
            caption: plural(c.saidas.registros, 'registro', 'registros'),
        },
        {
            id: 'resultado',
            title: 'Resultado',
            value: formatBRL(c.resultado.value),
            caption: 'Entradas - saídas',
        },
    ];
}

/** "Disponível" para todas as contas do filtro, "Por plano" quando so parte delas tem a flag. */
export function flagAvailability(f: FeatureFlagItem, base: number): string {
    if (base <= 0) return DASH;
    if (f.enabled >= base) return 'Disponível';
    if (f.enabled === 0) return 'Desabilitada';
    return 'Por plano';
}

/** "29 de 30 · 96,7%". */
export function flagCount(f: FeatureFlagItem, base: number): string {
    return `${formatInt(f.enabled)} de ${formatInt(base)} · ${formatPct(f.pct)}`;
}

/** "24 pagantes com flag". */
export function flagPayers(f: FeatureFlagItem): string {
    return `${formatInt(f.enabledPayers)} ${f.enabledPayers === 1 ? 'pagante' : 'pagantes'} com flag`;
}
